import { useCallback } from "react";
import { MediaService } from "$services";
import useAuth from "./useAuth";

const useMedia = (type: string) => {
  if (type) {
    // TODO use type
  }
  const { token } = useAuth();

  const getMedia = useCallback(
    async (mediaId: string) => {
      const res = await MediaService.getMedia(token, mediaId);
      return res;
    },
    [token]
  );

  const deleteMedia = useCallback(
    async (mediaId: string) => {
      const res = await MediaService.deleteMedia(token, mediaId);
      return res;
    },
    [token]
  );

  return {
    getMedia,
    deleteMedia,
  };
};

export default useMedia;
